import {BankOption, PurchaseItem} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Player, UserSource} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {AbstractShopBankPanel} from "@/scenes.ui/abstract-shop-bank-panel";
import {PurchaseItemPanel} from "@/scenes.ui/purchase-item-panel";
import TimeUtils from "@/utils/time-utils";
import Text = Phaser.GameObjects.Text;
import {Tr} from "@/i18n/i18n";
import Sprite = Phaser.GameObjects.Sprite;

export class SuperPackPanel extends AbstractShopBankPanel {

    public static PACKS_152: string[] = ['pack_5', 'pack_9', "pack_10", "pack_11", "pack_12", 'pack_ny_3', 'pack_ny_4', 'pack_mar_3', 'pack_mar_4'];
    public static PACKS_176: string[] = ['pack_mar_5', 'pack_mar_6'];
    public static PACKS_250: string[] = ['chain_1', 'chain_2', "chain_3", "chain_4", "chain_5", 'chain_ny_1', 'chain_ny_2', 'chain_ny_3'];
    public static PACKS_250_HERO: string[] = ['chain_6', 'chain_7'];
    public static PACKS_190: string[] = ['pack_16', 'pack_17', 'pack_18', 'pack_19', 'pack_20', 'pack_21', 'pack_22',
        'pack_23', 'pack_24', 'pack_25', 'pack_26'];

    private remainTimeText: Text | undefined = undefined;
    private updatingTill!: number;

    private bo!: BankOption;
    private receivedText: Text | undefined = undefined;
    private recievedCheck: Sprite | undefined = undefined;

    protected purchaseItems: PurchaseItemPanel[] = [];

    private heroDescCallback!: (heroId: string) => void;

    protected static TITLE_X: number = 125;

    constructor(scene: Phaser.Scene, x: number, y: number, bo: BankOption, player: Player, userSource: UserSource,
                buyCallback: () => void, heroDescCallback: (heroId: string) => void, isReward: boolean = false, productPriceView: string | undefined = undefined) {
        super(scene, x, y, bo, player, userSource, buyCallback, isReward, productPriceView);
        this.bo = bo;
        this.heroDescCallback = heroDescCallback;

        const titleLight = SpriteUtils.addImage(this.scene, 140 - bo.title.length * 5, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight, 360 / 14 * bo.title.length * CU.S, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, bo.title.toUpperCase(), this.getTitlePosX(), 35,
            '#ffd054', 19, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#9b571a', 5);

        if (bo.decorationId == 'pack_1' || bo.decorationId == 'pack_2' || bo.decorationId == 'pack_8'
            || bo.decorationId == 'pack_ny_1' || bo.decorationId == 'pack_ny_2' || bo.decorationId == 'pack_mar_1' || bo.decorationId == 'pack_mar_2') {
            const darkness = SpriteUtils.addImage(this.scene, 0, this.getHeight(bo.decorationId), Keys.ATLAS_BANK_2, 'darkness_2')
                .setOrigin(0, 1);
            this.add(darkness);
        } else if (SuperPackPanel.PACKS_152.includes(bo.decorationId)) {
            if (bo.items.length === 1) {
                const darkness = SpriteUtils.addImage(this.scene, 135, this.getHeight(bo.decorationId), 'darkness_3', undefined)
                    .setOrigin(0, 1);
                this.add(darkness);
            }
        } else if (SuperPackPanel.PACKS_176.includes(bo.decorationId)) {
            if (bo.items.length === 1) {
                const darkness = SpriteUtils.addImage(this.scene, 135, this.getHeight(bo.decorationId), 'darkness_3', undefined)
                    .setOrigin(0, 1);
                this.add(darkness);
            }
        }

        this.initItems(bo);
        this.add([titleLight, titleText]);

        if (bo.validTill && bo.validTill > 0) {

            const remainSec = Math.floor((bo.validTill - TimeUtils.getServerTimeMs()) / 1000);

            // const watches = SpriteUtils.addImage(this.scene, 140 - bo.title.length * 5, 0, Keys.ATLAS_BANK_2, 'time')
            //     .setOrigin(0, 0);

            this.updatingTill = bo.validTill;

            this.remainTimeText = TextUtils.addTextAdvanced(scene, TimeUtils.getDurationTextForTimer(remainSec),
                595, this.getHeight(bo.decorationId) - 25,
                '#fbd777', 14, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL)
                .setOrigin(1, 0);

            this.add([this.remainTimeText]);
        }

        let timerId = setInterval(() => {
            if (!this.active) {
                clearInterval(timerId);
            } else {
                this.refreshTimer();
            }
        }, 1000);

        let desc = TextUtils.addTextAdvanced(this.scene, bo.description,
            this.getDescPosX(bo), this.getDescPosY(bo), this.getStrokeColor(), this.getDescFontSize(), 'normal', this.getDescWidth(bo),
            'left', 2, Fonts.MYRIADPRO_REGULAR)
            .setOrigin(0, 0);
        this.setDescStroke(desc);
        this.add(desc);
    }

    protected getStrokeColor(): string {
        return '#c9c9c9';
    }

    protected setDescStroke(desc: Text) {
        desc.setStroke('#2a2a2a', 2);
    }

    protected getTitlePosX(): number {
        return SuperPackPanel.TITLE_X;
    }

    protected getDescPosX(bo: BankOption): number {
        return 170;
    }

    protected getDescPosY(bo: BankOption): number {
        return this.getHeight(bo.decorationId) - 42;
    }

    protected getDescWidth(bo: BankOption): number {
        return 270;
    }

    protected getDescFontSize(): number {
        return 10;
    }

    protected getTextColor(): string {
        return '#70ff10';
    }

    private initItems(bo: BankOption) {

        if (bo.decorationId === 'pack_8' || bo.decorationId === 'pack_7') {
            if (bo.items.length === 4) {
                this.initItem(bo.decorationId, bo.items[0], 79, 160);
                this.initItem(bo.decorationId, bo.items[1], 193, 152);
                this.initItem(bo.decorationId, bo.items[2], 307, 152);
                this.initItem(bo.decorationId, bo.items[3], 421, 152);
            } else if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 90, 160);
                this.initItem(bo.decorationId, bo.items[1], 222, 146);
                this.initItem(bo.decorationId, bo.items[2], 350, 146);

            }

        } else if (bo.decorationId === 'pack_1' || bo.decorationId === 'pack_2'
            || bo.decorationId === 'pack_ny_1' || bo.decorationId === 'pack_ny_2') {

            if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 90, 160);
                this.initItem(bo.decorationId, bo.items[1], 222, 146);
                this.initItem(bo.decorationId, bo.items[2], 350, 146);

            }
            else if (bo.items.length === 4) {

                this.initItem(bo.decorationId, bo.items[0], 79, 160);
                this.initItem(bo.decorationId, bo.items[1], 193, 146);
                this.initItem(bo.decorationId, bo.items[2], 307, 146);
                this.initItem(bo.decorationId, bo.items[3], 421, 146);

            }

        } else if (SuperPackPanel.PACKS_152.includes(bo.decorationId)) {

            if (bo.items.length === 1) {

                this.initItem(bo.decorationId, bo.items[0], 70, 105);

            }
            else if (bo.items.length === 2) {

                this.initItem(bo.decorationId, bo.items[0], 70, 105);
                this.initItem(bo.decorationId, bo.items[1], 220, 105);

            }
            else if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 70, 105);
                this.initItem(bo.decorationId, bo.items[1], 220, 105);
                this.initItem(bo.decorationId, bo.items[2], 370, 105);

            }

        } else if (SuperPackPanel.PACKS_176.includes(bo.decorationId)) {

            if (bo.items.length === 1) {

                this.initItem(bo.decorationId, bo.items[0], 70, 130);

            }
            else if (bo.items.length === 2) {

                this.initItem(bo.decorationId, bo.items[0], 70, 130);
                this.initItem(bo.decorationId, bo.items[1], 220, 130);

            }
            else if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 70, 130);
                this.initItem(bo.decorationId, bo.items[1], 220, 130);
                this.initItem(bo.decorationId, bo.items[2], 370, 130);

            }

        } else if (SuperPackPanel.PACKS_190.includes(bo.decorationId)) {

            if (bo.items.length === 1) {

                this.initItem(bo.decorationId, bo.items[0], 70, 140);

            } else if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 70, 144);
                this.initItem(bo.decorationId, bo.items[1], 220, 144);
                this.initItem(bo.decorationId, bo.items[2], 370, 144);

            }

        } else if (SuperPackPanel.PACKS_250.includes(bo.decorationId)) {
            if (bo.items.length === 3) {

                this.initItem(bo.decorationId, bo.items[0], 90, 180);
                this.initItem(bo.decorationId, bo.items[1], 222, 180);
                this.initItem(bo.decorationId, bo.items[2], 350, 180);

            } else if (bo.items.length === 2) {

                this.initItem(bo.decorationId, bo.items[0], 90, 180);
                this.initItem(bo.decorationId, bo.items[1], 222, 180);

            } else if (bo.items.length === 1) {

                this.initItem(bo.decorationId, bo.items[0], 90, 180);

            }
        } else if (SuperPackPanel.PACKS_250_HERO.includes(bo.decorationId)) {
            if (bo.items.length === 4) {
                this.initItem(bo.decorationId, bo.items[0], 79, 160);
                this.initItem(bo.decorationId, bo.items[1], 193, 146);
                this.initItem(bo.decorationId, bo.items[2], 307, 146);
                this.initItem(bo.decorationId, bo.items[3], 421, 146);
            } else if (bo.items.length === 3) {
                this.initItem(bo.decorationId, bo.items[0], 81, 160);
                this.initItem(bo.decorationId, bo.items[1], 208, 186);
                this.initItem(bo.decorationId, bo.items[2], 332, 186);
            }
        } else if (bo.decorationId === 'pack_mar_1' || bo.decorationId === 'pack_mar_2') {
            if (bo.items.length === 3) {
                this.initItem(bo.decorationId, bo.items[0], 81, 160);
                this.initItem(bo.decorationId, bo.items[1], 220, 155);
                this.initItem(bo.decorationId, bo.items[2], 370, 155);
            }
        }

    }

    private initItem(decorationId: string, pi: PurchaseItem, x: number, y: number) {
        let pip = new PurchaseItemPanel(this.scene, x, y, decorationId, pi, this.heroDescCallback);
        this.purchaseItems.push(pip);
        this.add(pip);
    }

    public getItems(): PurchaseItemPanel[] {
        return this.purchaseItems;
    }

    public setRecieved(recieved: boolean, gotText: string = Tr('got')): void {
        if (!!this.buyButton) {
            this.buyButton.setVisible(!recieved);
        }
        if (!!this.buyPriceText) {
            this.buyPriceText.setVisible(!recieved);
        }
        if (!!this.valuteText) {
            this.valuteText.setVisible(!recieved);
        }

        if (recieved) {
            if (!this.recievedCheck) {
                this.recievedCheck = SpriteUtils.addSprite(this.scene!, 530, this.getBuyButtonPos(this.bo.decorationId), Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK);
                this.add(this.recievedCheck);
            }
            this.recievedCheck!.setVisible(recieved);

            if (!this.receivedText) {
                this.receivedText = TextUtils.addTextAdvanced(this.scene!, gotText.toLowerCase(),
                    this.buyButton.x / CU.S, this.buyButton.y / CU.S + 55,
                    '#71ff66', 14, 'normal', 200, 'center', 2, Fonts.BENGALY_NORMAL)
                this.add(this.receivedText);
            }
            this.receivedText!.setVisible(recieved);
        }
    }

    protected getBackAtlas(decorationId: string) {
        return decorationId;
    }

    protected getBackKey(decorationId: string) {
        return undefined;
    }

    protected getHeight(decorationId: string): number {
        if (decorationId === 'pack_3') {
            return 155;
        } else if (SuperPackPanel.PACKS_152.includes(decorationId)) {
            return 152;
        } else if (SuperPackPanel.PACKS_176.includes(decorationId)) {
            return 176;
        } else if (SuperPackPanel.PACKS_190.includes(decorationId)) {
            return 190;
        }
        return 230;
    }

    protected getGemsCountLinePosY() {
        return 75;
    }

    protected getOfferLinePosY() {
        return 120;
    }

    public refreshTimer(): void {
        if (this.active && this.remainTimeText && this.updatingTill) {
            const remainSec = Math.floor((this.updatingTill - TimeUtils.getServerTimeMs()) / 1000);
            this.remainTimeText.setText(remainSec > 0 ? TimeUtils.getDurationText(remainSec) : Tr('gotovo'));
        }
    }

    protected disableTimer() {
        if (this.remainTimeText) {
            this.remainTimeText.setVisible(false);
            this.remainTimeText = undefined;
        }
    }

    protected getBuyButtonPos(decorationId: string) {
        if (SuperPackPanel.PACKS_152.includes(decorationId)) {
            return this.getHeight(decorationId) / 2 - 18;
        } else if (SuperPackPanel.PACKS_176.includes(decorationId)) {
            return this.getHeight(decorationId) / 2 - 18;
        } else if (SuperPackPanel.PACKS_190.includes(decorationId)) {
            return this.getHeight(decorationId) / 2 - 18;
        }
        return this.getHeight(decorationId) / 2 - 4;
    }
}
